import { Injectable } from '@angular/core';
import * as _ from "lodash";
import * as title from "../../config/title";
import * as legend from "../../config/legend";
import * as series from "../../config/series";
import * as toolbox from "../../config/toolbox";
import * as tooltip from "../../config/tootip";
import * as xAxis from "../../config/xAxis";
import * as yAxis from "../../config/yAxis";
import * as color from "../../config/colors";
import * as backgroundColor from "../../config/backgroundColor";
import * as datazoom from "../../config/datazoom";
import * as textStyle from '../../config/textStyle'
import { CommonService } from '../../service/common.service';
import { legendPosition } from './rose-pie-interface';
import { ECharts } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';


@Injectable({
  providedIn: 'root'
})
export class RosePieService {

  constructor(
    private commonService: CommonService
  ) { }

  style = this.commonService.changeFontSize();

  getDefaultOptionsOfRosePieChart = () => {
    let style = this.commonService.changeFontSize();

    let defaultOptions = {
      title: title.getBottomTitle(style),
      backgroundColor: backgroundColor.backgroundColor,
      color: color.defaultColors,
      legend: legend.getLegendRightScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getTooltipOfPieChart(style),
      series: series.getRosePieChartSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return defaultOptions;
  }
  // 更改toolbox显示状态
  changeToolboxShow(chartOptions, show: boolean) {
    // chartOptions.toolbox.show = show;
  }
  // 更改legend位置
  changeLegendPosition(chartOption, legendPosition: legendPosition) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case 'bottom':
        chartOption.legend = legend.getLegendBottomScroll(style)
        break;
      case 'right':
        chartOption.legend = legend.getLegendRightScroll(style)
        break;
      case 'top':
        chartOption.legend = legend.getLegendTopScroll(style)
        break;
      case 'none':
        chartOption.legend = legend.getLegendNotShow(style)
        break;
    }
  }

  // 更改legend显示状态
  changeLegendShowStatus(chartOptions, showLegend: boolean) {
    chartOptions.legend.show = showLegend;
  }

  // 设置chart数据
  changeChartData(chartOptions, bcacChartData: { name: string, value: string | number }[]) {
    chartOptions.series[0].data = bcacChartData;
  }
  // 更改系列名
  changeSeriesName(chartOptions, seriesName: string) {
    chartOptions.series[0].name = seriesName;
  }

  // 更改玫瑰图的类型
  changePieChartRoseType(chartOptions, bcacRoseType: 'radius' | 'area') {
    if (bcacRoseType !== 'radius' && bcacRoseType !== 'area') {
      bcacRoseType = 'area';
    }
    chartOptions.series[0].roseType = bcacRoseType;
  }
  // 设置圆心的位置
  changeRadius(chartOptions, bcacPieChartRadius: Array<string> | Array<number>) {
    chartOptions.series[0].radius = bcacPieChartRadius;
  }

  // 设置饼图的半径
  changeCenter(chartOptions, bcacPieChartCenter: Array<string> | Array<number>) {
    chartOptions.series[0].center = bcacPieChartCenter;
  }

  // 修改label状态
  changeLabelStatus(chartOption, showLabel: boolean) {
    chartOption.series[0].label.show = showLabel;
  }
  // 修改labelLine length
  changeLabelLineLength(chartOption, labelLineLength: number) {
    chartOption.series[0].labelLine.length = labelLineLength;
  }
  // 修改labelLine length2
  changeLabelLineLength2(chartOption, labelLineLength2: number) {
    chartOption.series[0].labelLine.length2 = labelLineLength2;
  }

  setLegendPosition(option: any, legendPosition: string) {
    if (legendPosition === "top") {
      option.grid = this.style.topLegendGrid;
      option.legend = legend.getTopLegend(this.style);
    } else if (legendPosition === "right") {
      option.grid = this.style.rightLegendGrid;
      option.legend = legend.getLegendRightScroll(this.style);
    } else if (legendPosition === "none") {
      option.grid = this.style.noLegendGrid;
      option.legend = legend.getLegendNotShow(this.style);
    } else {
      //默认bottom
      option.grid = this.style.interval;
      option.legend = legend.getLegendBottomScroll(this.style);
    }
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }
  // 修改标题选项
  changeTitleOption(options, chartTitle) {
    options.title = title.getBottomTitle(this.style, true, chartTitle)
  }

  changeLabelShowStatus(chartOptions, labelShow) {
    if (typeof (labelShow) == 'string') {
      labelShow = JSON.parse(labelShow)
    }
    chartOptions.series[0].label.show = labelShow;
  }

  openRosePieSmallMode(chartOption, isSmallMode, legendPosition) {
    if (isSmallMode) {
      switch (legendPosition) {
        case 'bottom':
          chartOption.grid = this.style.smallInterval;
          break;
        case 'top':
          chartOption.grid = this.style.smallTopLegendGrid;
          break;
        case 'right':
          chartOption.grid = this.style.smallRightLegendGrid;
          break;
        case 'none':
          chartOption.grid = this.style.smallNoLegendGrid;
          break;
        default:
          chartOption.grid = this.style.smallInterval;
          break;
      }
    } else {
      switch (legendPosition) {
        case 'bottom':
          chartOption.grid = this.style.interval;
          break;
        case 'top':
          chartOption.grid = this.style.topLegendGrid;
          break;
        case 'right':
          chartOption.grid = this.style.rightLegendGrid;
          break;
        case 'none':
          chartOption.grid = this.style.noLegendGrid;
          break;
        default:
          chartOption.grid = this.style.interval;
          break;
      }
    }
  }

  changeLabelType(chartOption, type) {
    if (type == "value") {
      chartOption.series.forEach(e => {
        e.label.formatter = "{b} : {c}"
      });
      chartOption.tooltip.formatter = (params) => {
        let str = '';
        str = '<span>' + params.seriesName + '<span><br/>'
        str += '<span style="color:' + params.color + '">' + params.marker + params.name + '：</span> <b>' + params.value + '</b><br/>'
        return str;
      }
    } else if (type == "percent") {
      chartOption.series.forEach(e => {
        e.label.formatter = (params) => {
          let str = '';
          str = params.name + ' : ' + params.percent.toFixed(1) + "%";
          return str;
        }
      });
      chartOption.tooltip.formatter = (params) => {
        let str = '';
        str = '<span>' + params.seriesName + '<span><br/>'
        str += '<span style="color:' + params.color + '">' + params.marker + params.name + '：</span> <b>' + params.percent.toFixed(1) + '% </b><br/>'
        return str;
      }
    }

  }

  // label的对齐方式
  changeLabelAlignTo(chartOption, alignTo: 'none' | 'labelLine' | 'edge') {
    if (alignTo == 'edge') {
      chartOption.series[0].label.alignTo = alignTo;
    } else if (alignTo == 'labelLine') {
      chartOption.series[0].label.alignTo = alignTo;
    } else if (alignTo == 'none') {
      chartOption.series[0].label.alignTo = alignTo;
    }
  }
  // label的边距
  changeLabelMargin(chartOption, margin: string | number) {
    chartOption.series[0].label.margin = margin;
  }
  // 修改label出血线的大小
  changeLabelBleedMargin(chartOption, bleedMargin) {
    chartOption.series[0].label.bleedMargin = bleedMargin;
  }
}
